import React from 'react';
import GenerationHealth from './components/GenerationHealth/GenerationHealth';
import SharedAuth from './sharedAuth/SharedAuth';
import './App.css';
import Layout from './components/Layout/Layout';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PrivateRoute from'../src/components/PrivateRoute'
import Account from '../src/components/Account/Account'
import Login from './components/Login/loginPage';
import ConfirmEmail from './components/Login/ConfirmEmail';
import { EMAIL_CONFIRMED_PATH, isEmailConfirmationCallback } from './components/Login/emailConfirmation';
import Buycredits from './components/BuyCredits/Buycredits.js';
import resetPassword from './components/Login/resetPassword.js';
import MyWorksheets from './components/MyWorksheets/MyWorksheets.jsx';
import WorksheetView from './components/WorksheetView/WorksheetView.jsx';

// If Supabase falls back to the Site URL, a confirmation link lands on "/"; keep its hash/query for the confirm page.
export const RootRedirect = () => {
  const location = useLocation();
  if (isEmailConfirmationCallback(location)) {
    return <Navigate to={{ pathname: EMAIL_CONFIRMED_PATH, search: location.search, hash: location.hash }} replace />;
  }
  const resume=sessionStorage.getItem('worksheep-auth-resume');
  if(resume?.startsWith('/auth/authorize?')) return <Navigate to={resume} replace />;
  const returnPath=sessionStorage.getItem('worksheep-return-path');
  sessionStorage.removeItem('worksheep-return-path');
  if(returnPath && /^\/(create(?:\/|$)|worksheet\/|worksheets(?:\?|$)|account(?:\/|\?|$)|buycredits(?:\?|$))/.test(returnPath) && !returnPath.includes('\\')) return <Navigate to={returnPath} replace />;
  return <Navigate to="/create" replace />;
};

function App() {
  return (
    <div>
        <Router>
          <Routes>
            <Route path="/auth/connect" element={<SharedAuth />} />
            <Route path="/auth/authorize" element={<SharedAuth mode="authorize" />} />
            <Route path="/auth/logout" element={<SharedAuth mode="logout" />} />
            <Route path="/login" element={<Login />} />
            <Route path={EMAIL_CONFIRMED_PATH} element={<ConfirmEmail />} />
            <Route path="/" element={<RootRedirect />} />
            <Route path="/create" element={<PrivateRoute element={Layout} />} />
            <Route path="/create/:templateId" element={<PrivateRoute element={Layout} />} />
            <Route path="/worksheet/:id" element={<PrivateRoute element={WorksheetView} />} />
            <Route path="/reset-password" element={<PrivateRoute element={resetPassword} />} />
            <Route path="/account/admin/generation-health" element={<PrivateRoute element={GenerationHealth} />} />
            <Route path="/account" element={<PrivateRoute element={Account} />} />
            <Route path="/buycredits" element={<PrivateRoute element={Buycredits} />} />
            <Route path="/worksheets" element={<PrivateRoute element={MyWorksheets} />} />
          </Routes>
        </Router>
    </div>
  );
}

export default App;
